<template>
  <div>
    <form-message v-if="showMessage" :message="message" @close="messageClose">
    </form-message>
    <div class="register_page_title mb-12 pb-sm-5 pb-xs-0">
      Crea tu contraseña <span class="material-icons-outlined">info</span>
    </div>

    <v-card
      class="mx-auto mb-6"
      max-width="395"
      outlined
      style="border-color: #00AAE7"
    >
      <v-card-title class="primary--text" style="font-size: 17px;font-weight: 600;"
        >La contraseña debe:</v-card-title
      >
      <v-card-text>
        <ul>
          <li
            v-for="(property, index) in properties_password"
            :key="index"
            style="font-size: 16px;line-height: 22px; font-weight: 600;"
          >
            <span color="teal accent-4">{{ property }}</span>
          </li>
        </ul>
      </v-card-text>
    </v-card>

    <div class="register_page_fields">

      <form>
        <v-row>
          <v-col cols="12" xs="12" sm="12" md="12">
            <v-text-field
              filled
              label="Usuario"
              :error-messages="usernameErrors"
              @change="$v.username.$touch()"
              @blur="$v.username.$touch()"
              @focus="$v.username.$reset()"
              v-model="username"
              readonly
            ></v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="12" md="12">
            <v-text-field
              :type="showPass ? 'text' : 'password'"
              filled
              label="Contraseña"
              :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append="showPass = !showPass"
              v-model="password"
              :error-messages="passwordErrors"
              @change="$v.password.$touch()"
              @blur="$v.password.$touch()"
              @focus="$v.password.$reset()"
            ></v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="12" md="12">
            <v-text-field
              :type="showConfirmPass ? 'text' : 'password'"
              filled
              label="Confirmar Contraseña"
              :append-icon="showConfirmPass ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append="showConfirmPass = !showConfirmPass"
              v-model="confirmPassword"
              :error-messages="confirmPasswordErrors"
              @change="$v.confirmPassword.$touch()"
              @blur="$v.confirmPassword.$touch()"
              @focus="$v.confirmPassword.$reset()"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="mt-5 mt-sm-12">
            <v-btn
              block
              color="primary"
              class="uppercase"
              @click="send"
              :loading="loading"
            >
              Guardar
            </v-btn>
          </v-col>
        </v-row>
      </form>
    </div>
  </div>
</template>
<script>
import FormMessage from "@/components/common/FormMessage";
import axios from "@/axios-auth";
import { validationMixin } from "vuelidate";
import { mapState } from "vuex";
import jwt from "jwt-simple";

const { required, sameAs, minLength } = require("vuelidate/lib/validators");

export default {
  props: ["userData", "resultRegister"],
  components: {
    "form-message": FormMessage
  },
  data() {
    return {
      loading: false,

      showPass: false,
      showConfirmPass: false,
      showMessage: false,
      message: {
        type: "success",
        title: "¡Contraseña se guardó exitosamente!",
        subtitle: "Será redireccionado para iniciar..."
      },
      username: "",
      password: "",
      confirmPassword: "",
      properties_password: [
        "Tener un mínimo de 8 caracteres",
        "Tener una letra mayúscula",
        "Tener una letra minúscula",
        "Tener al menos un número",
        "Tener al menos un carácter especial: @ # $",
        "No utilizar los siguientes caracteres: ñ ¡ ¨ ¿"
      ],
    };
  },
  mixins: [validationMixin],
  validations: {
    username: { required },
    password: {
      required,
      minLength: minLength(8),
      strongPassword(password) {
        return /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+])[A-Za-z\d!@#$%^&*()−_+]{8,}$/.test(
          password
        );
      },
      upperPassword(password) {
        return /^(?=.*[A-Z]).{8,}$/.test(password);
      },
      lowerPassword(password) {
        return /^(?=.*[a-z]).{8,}$/.test(password);
      },
      specialCaracterPassword(password) {
        return /(?=.*[!@#$%^&*()−_+])/.test(password);
      },
      numberPassword(password) {
        return /^(?=.*\d).{8,}$/.test(password);
      }
    },
    confirmPassword: {
      required,
      minLength: minLength(8),
      strongPassword(confirmPassword) {
        return /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+])[A-Za-z\d!@#$%^&*()−_+]{8,}$/.test(
          confirmPassword
        );
      },
      upperPassword(confirmPassword) {
        return /^(?=.*[A-Z]).{8,}$/.test(confirmPassword);
      },
      lowerPassword(confirmPassword) {
        return /^(?=.*[a-z]).{8,}$/.test(confirmPassword);
      },
      specialCaracterPassword(confirmPassword) {
        return /(?=.*[!@#$%^&*()−_+])/.test(confirmPassword);
      },
      numberPassword(confirmPassword) {
        return /^(?=.*\d).{8,}$/.test(confirmPassword);
      },
      sameAsPassword: sameAs("password")
    }
  },
  methods: {
    send() {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        this.register();
      }
    },
    register() {
      this.loading = true;
      let data = {
        first_name: this.userData.first_name,
        middle_name: this.userData.second_name,
        last_name: this.userData.first_surname,
        mother_last_name: this.userData.second_surname,
        document_type: this.userData.document_type.toString(),
        document_number: this.userData.document_number,
        email: this.userData.email,
        phone: this.userData.mobile_phone,
        student_id: this.resultRegister.student_id,
        sii_code: "",
        card_code: "",
        password: this.password,
        username: this.username,
        confirm_password: this.password,
        application_id: this.resultRegister.student_id
      };
      axios
        .post(`users/create/`, data)
        .then(response => {
          this.showMessage = true;
          setTimeout(() => {
            this.login();
          }, 10000);
        })
        .catch(err => {
          this.loading = false;
          console.error(err);
        });
    },
    messageClose() {
      this.message = null;
    },
    login() {
      axios
        .post("users/login/", {
          username: this.username,
          password: "Tst#s0s0UP"
          // password: this.password
        })
        .then(response => {
          var secret = this.secretKeyJwt;
          response.data.username = this.username;
          var token = jwt.encode(response.data, secret);

          if (token == null || token == undefined || token == "") {
            return;
          } else {
            this.$store.dispatch("guardarToken", {
              token: token,
              keyJwt: this.secretKeyJwt
            });
            this.$store.dispatch(
              "saveNotifications",
              response.data.notifications
            );
          }
          if (this.$store.state.usuario != null) {
            this.$router.push("/principal");
          }
        })
        .catch(err => {
          location.reload();
          this.loading = false;
          console.error(err);
        });
    }
  },
  computed: {
    ...mapState(["secretKeyJwt"]),
    usernameErrors() {
      const errors = [];
      if (!this.$v.username.$dirty) return errors;
      !this.$v.username.required && errors.push("Usuario es requerido");
      return errors;
    },
    passwordErrors() {
      const errors = [];
      if (!this.$v.password.$dirty) return errors;
      !this.$v.password.required && errors.push("Contraseña es requerida");
      !this.$v.password.minLength && errors.push("Mínimo 8 caracteres");
      !this.$v.password.lowerPassword &&
        errors.push("Mínimo una letra minúscula");
      !this.$v.password.upperPassword &&
        errors.push("Mínimo una letra mayúscula");
      !this.$v.password.numberPassword && errors.push("Mínimo un número");
      !this.$v.password.specialCaracterPassword &&
        errors.push("Mínimo un caracter especial: (@, # o $)");
      this.password.search("ñ") > -1 &&
        errors.push("No utilizar los siguientes caracteres: ñ ¡ ¨ ¿");
      this.password.search("¡") > -1 &&
        errors.push("No utilizar los siguientes caracteres: ñ ¡ ¨ ¿");
      this.password.search("¨") > -1 &&
        errors.push("No utilizar los siguientes caracteres: ñ ¡ ¨ ¿");
      this.password.search("¿") > -1 &&
        errors.push("No utilizar los siguientes caracteres: ñ ¡ ¨ ¿");
      return errors;
    },
    confirmPasswordErrors() {
      const errors = [];
      if (!this.$v.confirmPassword.$dirty) return errors;
      !this.$v.confirmPassword.required &&
        errors.push("Debe volver a ingresar la contraseña");
      !this.$v.confirmPassword.minLength && errors.push("Mínimo 8 caracteres");
      !this.$v.confirmPassword.lowerPassword &&
        errors.push("Mínimo una letra minúscula");
      !this.$v.confirmPassword.upperPassword &&
        errors.push("Mínimo una letra mayúscula");
      !this.$v.confirmPassword.numberPassword &&
        errors.push("Mínimo un número");
      !this.$v.confirmPassword.specialCaracterPassword &&
        errors.push("Mínimo un caracter especial: (@, # o $)");
      this.confirmPassword.search("ñ") > -1 &&
        errors.push("No utilizar los siguientes caracteres: ñ ¡ ¨ ¿");
      this.confirmPassword.search("¡") > -1 &&
        errors.push("No utilizar los siguientes caracteres: ñ ¡ ¨ ¿");
      this.confirmPassword.search("¨") > -1 &&
        errors.push("No utilizar los siguientes caracteres: ñ ¡ ¨ ¿");
      this.confirmPassword.search("¿") > -1 &&
        errors.push("No utilizar los siguientes caracteres: ñ ¡ ¨ ¿");
      !this.$v.confirmPassword.sameAsPassword &&
        errors.push("Debe de coincidir con la contraseña");
      return errors;
    }
  },
  mounted() {
    if (this.resultRegister)
      this.username = this.resultRegister.user_red_proposed;
  },
  activated(){
    if (this.resultRegister)
      this.username = this.resultRegister.user_red_proposed;
  }
};
</script>
